import { render, staticRenderFns } from "./EmpresaCsd.vue?vue&type=template&id=530ab3e0&"
import script from "./EmpresaCsd.vue?vue&type=script&lang=js&"
export * from "./EmpresaCsd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports